import { NgModule } from '@angular/core';
import { AlertService } from '../core/singletons/alert/alert.service';

@NgModule({
  providers: [AlertService],
})
export class SharedModule {}
